(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["premium-minimal-cart"] && !Shopify.designMode) return;
  try {
    
  class PremiumMinimalCart extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-quantity-control]').forEach((control) => {
        const input = control.querySelector('[data-quantity-input]');
        const minus = control.querySelector('[data-quantity-minus]');
        const plus = control.querySelector('[data-quantity-plus]');
        const line = Number(control.dataset.cartLine);

        const changeQuantity = async (quantity) => {
          const nextQuantity = Math.max(0, quantity);
          const previousQuantity = Number(input.value || 0);
          input.value = nextQuantity;
          control.setAttribute('aria-busy', 'true');
          minus.disabled = true;
          plus.disabled = true;
          input.disabled = true;

          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart/change.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                line,
                quantity: nextQuantity
              })
            });

            if (!response.ok) {
              throw new Error('Cart quantity update failed');
            }

            window.location.reload();
          } catch (error) {
            input.value = previousQuantity;
            control.removeAttribute('aria-busy');
            minus.disabled = false;
            plus.disabled = false;
            input.disabled = false;
          }
        };

        minus?.addEventListener('click', () => {
          changeQuantity(Number(input.value || 0) - 1);
        });

        plus?.addEventListener('click', () => {
          changeQuantity(Number(input.value || 0) + 1);
        });

        input?.addEventListener('change', () => {
          changeQuantity(Number(input.value || 0));
        });
      });
    }
  }

  if (!customElements.get('premium-minimal-cart')) {
    customElements.define('premium-minimal-cart', PremiumMinimalCart);
  }

  } catch(e) { console.error(e); }
})();
})();
